/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_GInputs */

const en_tut_audio_g = /** @type {(inputs: Tut_Audio_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two ways to talk casually without scheduling anything: voice for the people closest to you, and text that is deliberately not kept.`)
};

const id_tut_audio_g = /** @type {(inputs: Tut_Audio_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua cara mengobrol ringan tanpa menjadwalkan apa pun: suara untuk rekan terdekat, dan teks yang sengaja tidak disimpan.`)
};

/**
* | output |
* | --- |
* | "Two ways to talk casually without scheduling anything: voice for the people closest to you, and text that is deliberately not kept." |
*
* @param {Tut_Audio_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_g = /** @type {((inputs?: Tut_Audio_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_g(inputs)
	return en_tut_audio_g(inputs)
});